import { OpenAPI } from "@propertelligent/client-api";
import { UserLoginData } from "../components/common/charts/Enums";
import { USERS, USER_ROLES } from "../constants/constants";

export const loginResponseHandler = (res: any) => {
  sessionStorage.setItem(UserLoginData.token, res.data.success.token);
  OpenAPI.TOKEN = res.data.success.token;

  sessionStorage.setItem(
    UserLoginData.user_name,
    res.data.success.firstName + " " + res.data.success.lastName
  );
  sessionStorage.setItem(
    UserLoginData.user_id.toString(),
    res.data.success.userId
  );
  sessionStorage.setItem(
    UserLoginData.organization_id,
    res.data.success.organizationUserInfo?.organizationId
  );
  sessionStorage.setItem(
    UserLoginData.currency_symbol,
    res.data.success.currencySymbol
  );

  sessionStorage.setItem(
    UserLoginData.permissions,
    JSON.stringify(res.data.success.organizationUserInfo?.permissions || {})
  );

  sessionStorage.setItem("userOnboarded", res.data.success.userOnboarded);
  sessionStorage.setItem("userRoleId", res?.data?.success?.userRoleId);

  if (USER_ROLES[res?.data?.success?.userRoleId] === USERS.TENANT) {
    sessionStorage.setItem(
      "tenantInfo",
      JSON.stringify(res?.data?.success?.tenantInfo)
    );
  } else if (USER_ROLES[res?.data?.success?.userRoleId] === USERS.CONTRACTOR) {
    sessionStorage.setItem(
      "contractorInfo",
      JSON.stringify(res?.data?.success?.contractorInfo)
    );
  }
};
